import { useComponent } from './useComponent';
import { SidebarContainer } from './styled';
export function EsigningSidebar() {
    const component = useComponent();
    return <SidebarContainer>{component}</SidebarContainer>;
}
